import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import SiteLayout from "../components/feature/SiteLayout";
import Home from "../pages/home/page";
import TopicsPage from "../pages/topics/page";
import RankingsPage from "../pages/rankings/page";
import TopicDetailPage from "../pages/topic/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "topics", element: <TopicsPage /> },
      { path: "rankings", element: <RankingsPage /> },
      { path: "topic/:slug", element: <TopicDetailPage /> },
      { path: "about", element: <AboutPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;